/**
 * Will match if there are two or more leading slashes in a string.
 * Matches on forward or backward slashes. (non-specific order)
 */
const LEADING_SLASHES_REGEX = /^[/\\]{2,}/;

/**
 * Use to prevent redirects to other domains by removing leading double-slashes.
 * @param str The URL string to modify.
 * @returns {string} The sanitized URL string.
 */
export const normalizeSlashes = (str: string) =>
  str.replace(LEADING_SLASHES_REGEX, '/');
